import { Container, ContainerPadding, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';

export const LegalDatosPersonalesLeads = () => {
	return (
		<Container wrap={'always'} padding={{ top: ContainerPadding.static250 }}>
			<Text appearance={TokenTextAppearance.copy200}>Tus datos de contacto y preferencias serán compartidos con el experto que hayas seleccionado, con el fin de que este pueda dar respuesta a tu solicitud de información.</Text>
		</Container>
	);
};
